import { useNavigate } from 'react-router-dom';

import useProtectAction from '@/hooks/useProtectAction';
import useStateHandler from '@/hooks/useStateHandler';

import './styles/SingUpLogInButton.css';

export default function SingUpLogInButton({ onIntent }) {
  const privateActionHandler = useProtectAction({ typeOfProtection: "USER_ACCOUNT_REQUIRED" });
  const navigate = useNavigate();
  const { state, stateHandler } = useStateHandler();

  const handleClick = () => {
    if (typeof onIntent === "function") {
      onIntent();
    }

    if (!state?.user_session) {
      const reason = state?.unregisteredUser || "guest_rest";
      stateHandler.set("unregisteredUser", reason);
      stateHandler.set("showAuthPopup", "sign-up");
      stateHandler.set("action_denied", "USER_ACCOUNT_REQUIRED");
    }

    privateActionHandler(() => navigate("/profile"));
  };

  return (
    <div
      className="unregistered-user__signlogin-button"
      onClick={handleClick}
    >
      <span>Sign up / Log in with Email</span>
    </div>
  );
}
